// If a video fails to load, log an error in the console
export default function handleVideoErrors() {
  document.addEventListener("DOMContentLoaded", function() {
    let videos = document.querySelector("video") ? [].slice.call(document.querySelectorAll("video[data-lazy]")) : null;

    if (videos) {
      videos.forEach(function(video) {
        video.addEventListener("error", () => {
          console.error(`${video.error.constructor.name}, code: ${video.error.code}, message: ${video.error.message}, Error loading: ${video.src}`);
        });
      });
    }
  });
}
